import React from 'react';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';

export const FDCDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Fully Developed Claim program</h3>
    <p>
      You can apply using the Fully Developed Claim (FDC) program if you’ve
      uploaded all the supporting documents or additional forms needed to
      support your claim.
    </p>
    <p>
      <va-link
        href="/disability/how-to-file-claim/evidence-needed/fully-developed-claims/"
        text="Learn more about the FDC program"
        external
      />
    </p>
    <p>
      <va-link
        href="/disability/how-to-file-claim/evidence-needed/"
        text="View the evidence requirements for disability claims"
        external
      />
    </p>
  </div>
);

export const FDCWarning = (
  <va-alert status="info" uswds>
    <p className="vads-u-margin-y--0">
      Since you’ve uploaded all your supporting documents, your claim will be
      submitted as a fully developed claim.
    </p>
  </va-alert>
);

export const noFDCWarning = (
  <va-alert status="info" uswds>
    <p>
      Since you’ll be sending in additional documents later, your application
      doesn’t qualify for the Fully Developed Claim program. We’ll review your
      claim through the standard claim process. With the standard claim process,
      you have up to 1 year from the date we receive your claim to turn in any
      information and evidence.
    </p>
    <p>You can turn in your evidence in 1 of 3 ways:</p>
    <ul>
      <li>
        Visit the Claim Status tool and upload your documents under the File
        tab.{' '}
        <va-link
          href="/track-claims"
          text="Track the status of your claims"
          external
        />
      </li>
      <li>
        Call Veterans Benefits Assistance at{' '}
        <va-telephone contact={CONTACTS.VA_BENEFITS} />, Monday through Friday,
        8:00 a.m. to 9:00 p.m. ET.
      </li>
      <li>
        Save your application and return to it later when you have your evidence
        ready to upload.
      </li>
    </ul>
  </va-alert>
);
